import { gql } from '@apollo/client'

export const NOTES = gql`
  query notes( $userId: String){
    notes(filter: { userId: $userId}) {
    _id
    title
    keyword
    content
    createdAt
  }}
`